import { EditCardRequest } from "tng-address-collection-shared/types/apiTypes.ts";

export const fallbackCard: EditCardRequest = {
  id: "",
  projectId: "",
  recipient: {
    firstName: "",
    lastName: "",
    salutationKind: "male",
    preferredLanguage: "en",
    companyName: "",
    email: "",
    title: "",
  },
  receivesGift: false,
  manualDispatch: false,
  formality: "formal",
  comment: "",
  departmentName: "",
  senderId: undefined,
};
